(function () {
  if (window.productSheetEmailSubmitInitialized) return;
  window.productSheetEmailSubmitInitialized = true;

  function getSelectedVariantTitle(wrapper) {
    const variantInput = wrapper
      .closest('[id^="MainProduct-"]')
      ?.querySelector('form[action*="/cart/add"] [name="id"]');
    const variantsElement = wrapper.querySelector('[data-product-sheet-email-variants]');

    if (!variantInput || !variantsElement) return wrapper.dataset.productVariant;

    try {
      const variants = JSON.parse(variantsElement.textContent);
      const selectedVariant = variants.find(
        (variant) => String(variant.id) === String(variantInput.value)
      );

      return selectedVariant?.title || wrapper.dataset.productVariant;
    } catch (error) {
      console.warn('Product sheet variant data could not be parsed.', error);
      return wrapper.dataset.productVariant;
    }
  }

  function getKlaviyoCompanyId() {
    const klaviyoScript = Array.from(document.scripts).find((script) =>
      script.src.includes('static.klaviyo.com/onsite/js/')
    );

    if (!klaviyoScript) return null;

    const scriptUrl = new URL(klaviyoScript.src);
    const companyIdFromQuery = scriptUrl.searchParams.get('company_id');

    if (companyIdFromQuery) return companyIdFromQuery;

    const pathParts = scriptUrl.pathname.split('/').filter(Boolean);
    const jsDirectoryIndex = pathParts.indexOf('js');
    return jsDirectoryIndex >= 0 ? pathParts[jsDirectoryIndex + 1] : null;
  }

  async function trackKlaviyo(wrapper, email) {
    const context = window.monsieurParisKlaviyoContext || {};
    const eventName = wrapper.dataset.klaviyoEvent || 'Product Sheet Requested';
    const companyId = getKlaviyoCompanyId();

    if (!companyId) {
      throw new Error('Klaviyo Site ID could not be found in the onsite script URL.');
    }

    const properties = {
      product_title: wrapper.dataset.productTitle,
      product_handle: wrapper.dataset.productHandle,
      product_url: wrapper.dataset.productUrl,
      product_image: wrapper.dataset.productImage,
      product_price: wrapper.dataset.productPrice,
      variant_title: getSelectedVariantTitle(wrapper),
      source: 'product_sheet_email',
      shopify_language: context.shopify_language,
      shopify_country: context.shopify_country,
      shopify_country_name: context.shopify_country_name
    };
    const payload = {
      data: {
        type: 'event',
        attributes: {
          properties,
          metric: {
            data: {
              type: 'metric',
              attributes: {
                name: eventName
              }
            }
          },
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                properties: {
                  shopify_language: context.shopify_language,
                  shopify_country: context.shopify_country,
                  shopify_country_name: context.shopify_country_name,
                  newsletter_source: 'product_sheet_email'
                }
              }
            }
          }
        }
      }
    };
    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), 10000);

    console.log('Sending product sheet Klaviyo event:', {
      companyId,
      eventName,
      email,
      properties
    });

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/events?company_id=${encodeURIComponent(companyId)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: '2026-07-15'
          },
          body: JSON.stringify(payload),
          signal: controller.signal
        }
      );

      console.log('Product sheet Klaviyo response:', response.status, response.statusText);

      if (!response.ok) {
        const responseBody = await response.text();
        throw new Error(
          `Klaviyo rejected the "${eventName}" event (${response.status}): ${responseBody}`
        );
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        throw new Error(`Klaviyo request timed out for the "${eventName}" event.`);
      }

      throw error;
    } finally {
      window.clearTimeout(timeoutId);
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-product-sheet-email-form')) return;

    event.preventDefault();
    event.stopPropagation();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const wrapper = form.closest('[data-product-sheet-email]');
    const message = wrapper?.querySelector('[data-product-sheet-email-message]');
    const submitButton = form.querySelector('.product-sheet-email__button');
    const emailInput = form.querySelector('input[name="contact[email]"]');
    const email = emailInput?.value.trim().toLowerCase();

    if (!wrapper || !message || !submitButton || !email) return;

    submitButton.disabled = true;
    wrapper.classList.add('is-loading');
    message.textContent = '';
    message.dataset.type = '';

    trackKlaviyo(wrapper, email)
      .then(() => {
        form.reset();
        message.textContent = wrapper.dataset.successMessage;
        message.dataset.type = 'success';
      })
      .catch((error) => {
        console.error('Product sheet Klaviyo event failed.', error);
        message.textContent = wrapper.dataset.errorMessage;
        message.dataset.type = 'error';
      })
      .finally(() => {
        submitButton.disabled = false;
        wrapper.classList.remove('is-loading');
      });
  }, true);
})();
